export function fixLink(link: string | number | undefined) {
  if (link && typeof link === 'string' && !link.toLowerCase().startsWith('http')) {
    return `https://${link}`;
  } else {
    return link;
  }
}
